(function () {
  function nudge(video) {
    video.muted = true;
    var attempt = video.play();
    if (attempt && typeof attempt.catch === 'function') {
      attempt.catch(function () {
        // Autoplay genuinely blocked (e.g. low-power mode) -- the poster
        // image, or the browser's own native tap-to-play affordance,
        // stays visible/usable as the fallback, nothing else to do here.
      });
    }
  }

  function watchSlide(video) {
    var slide = video.closest('.slideshow__slide');
    if (!slide) return;

    // A carousel slide that isn't the initially active one is typically
    // hidden/repositioned by Slick until the user reaches it -- calling
    // .play() once on page load, before that happens, is too early on
    // browsers (notably iOS Safari) that refuse to start a video that
    // isn't actually visible yet. Re-trigger playback specifically when
    // Slick marks this slide active.
    var observer = new MutationObserver(function () {
      if (slide.classList.contains('slick-active')) {
        nudge(video);
      }
    });
    observer.observe(slide, { attributes: true, attributeFilter: ['class'] });
  }

  function init() {
    var videos = document.querySelectorAll('[data-autoplay-video]');
    for (var i = 0; i < videos.length; i++) {
      var video = videos[i];
      nudge(video);
      video.addEventListener('loadedmetadata', function (event) {
        nudge(event.target);
      });
      watchSlide(video);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
